<script setup lang="ts">
import { useTranslate } from '@tolgee/vue'

import { useEditorStore } from '@/stores/Editor'

import BaseRadioGroup, { type RadioItem } from '@/components/common/BaseRadioGroup.vue'
import UploadImage from '@/components/common/UploadImage.vue'
import ColorPicker from '@/components/common/ColorPicker.vue'

const store = useEditorStore()
const { t } = useTranslate('local')

const items: RadioItem[] = [
  {
    label: t.value('EditorHeroSettings.image.withImage'),
    value: true,
    imageUrl: '/src/assets/images/editor/hero-with-image.webp',
  },
  {
    label: t.value('EditorHeroSettings.image.withoutImage'),
    value: false,
    imageUrl: '/src/assets/images/editor/hero-without-image.webp',
  },
]

const handleUpload = (value: string) => {
  store.editor.hero.image.url = value
}
</script>

<template>
  <div class="mb-5">
    <BaseRadioGroup
      v-model="store.editor.hero.image.visible"
      :items="items"
      :disabled="store.publishLoading"
    />
  </div>
  <div v-if="store.editor.hero.image.visible" class="mb-5">
    <h3>{{ t('EditorHeroSettings.image.upload.title') }}</h3>
    <p class="mb-5">{{ t('EditorHeroSettings.image.upload.description') }}</p>
    <UploadImage
      @upload="handleUpload"
      :default-image="store.editor.hero.image.url"
      :disabled="store.publishLoading"
    />
  </div>
  <div class="mb-5">
    <h3>
      {{ t('EditorHeroSettings.image.overlayColour.title') }}
    </h3>
    <p class="mb-5">{{ t('EditorHeroSettings.image.overlayColour.description') }}</p>
    <ColorPicker v-model="store.editor.hero.image.overlayColor" :disabled="store.publishLoading" />
  </div>
  <div class="mb-5">
    <h3 class="mb-5">
      {{ t('EditorHeroSettings.image.textColor.title') }}
    </h3>
    <ColorPicker v-model="store.editor.hero.image.textColor" :disabled="store.publishLoading" />
  </div>
</template>

<style lang="scss" scoped></style>
